import { render, staticRenderFns } from "./HomeGridProducts.vue?vue&type=template&id=175ee542&scoped=true&"
import script from "./HomeGridProducts.vue?vue&type=script&lang=js&"
export * from "./HomeGridProducts.vue?vue&type=script&lang=js&"
import style0 from "./HomeGridProducts.vue?vue&type=style&index=0&id=175ee542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175ee542",
  null
  
)

export default component.exports